import { QueryClientProvider, useQueryClient } from '@mint-lib/query-client';

import Sidebar from './organisms/Sidebar/Sidebar.jsx';

export default function AiSidebarRoot() {
  const queryClient = useQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Sidebar />
    </QueryClientProvider>
  );
}
